import { SpraypaintBase } from 'spraypaint';
import baseUrl from './helpers/baseUrl';

const ApplicationRecord = SpraypaintBase.extend({
  static: {
    baseUrl: baseUrl(),
    credentials: 'include',
    clientApplication: process.env.SPRAYPAINT_CLIENT_APPLICATION,
    generateAuthHeader(token) {
      return `Bearer ${token}`;
    },
    keyCase: { client: 'snake', server: 'snake' },
  },
});

export default ApplicationRecord;
